/*
  # selectedReferences Object
  This object is used to store the user's selections in the mask finder.
  ## Properties
  - `machine` (string): The selected machine. It's an empty string by default. Currently not being used in the code.
  - `mask` (string): The type of mask selected. It can be one of the following values: "Nasal", "Full Face", "Nasal Pillow". It's an empty string by default.
  - `brand` (string): The brand of the product. It can be one of the following values: "Resmed", "Philips", "Fisher & Paykel". It's an empty string by default.
  - `specialRequirement` (object): An object that contains special requirements.
    - `pacemaker` (boolean): Indicates whether the user has a pacemaker. It can be `true` or `false`. It's `null` by default.
    - `allergies` (boolean): Indicates whether the user has allergies. It can be `true` or `false`. It's `null` by default.
  */

const maskFinderResult = {
  "air-mini": {
    "full-face-mask": {
      resmed: {
        "00": [8054710993122, 8134829179106],
        "01": [8054710993122],
        10: [8054710993122, 8134829179106],
        11: [8054710993122],
      },
    },
    "nasal-pillow-mask": {
      resmed: {
        "00": [8137502916834],
        "01": [],
        10: [8137502916834],
        11: [],
      },
    },
    "nasal-mask": {
      resmed: {
        "00": [8137508684002],
        "01": [],
        10: [8137508684002],
        11: [],
      },
    },
  },
  others: {
    "full-face-mask": {
      resmed: {
        "00": [7605991604450, 8137513107682, 8304017539298],
        "01": [],
        10: [8137513107682, 8304017539298],
        11: [],
      },
      "philips-respironics": {
        "00": [7606002057442],
        "01": [],
        10: [],
        11: [],
      },
      "fisher-paykel": {
        "00": [8054725804258, 8137519661282, 8307704922338],
        "01": [],
        10: [8137519661282, 8307704922338],
        11: [],
      },
    },
    "nasal-pillow-mask": {
      resmed: {
        "00": [7606123561186, 7606125199586, 8054775972066, 8304016064738],
        "01": [],
        10: [8304016064738],
        11: [],
      },
      "fisher-paykel": {
        "00": [8239637856482, 7606131851490, 8239637856482],
        "01": [],
        10: [8239637856482, 7606131851490, 8239637856482],
        11: [],
      },
      "philips-respironics": {
        "00": [8054750347490, 7606026141922],
        "01": [],
        10: [8054750347490],
        11: [],
      },
    },
    "nasal-mask": {
      resmed: {
        "00": [8137508684002, 7606109700322, 8004917952738],
        "01": [],
        10: [8137508684002, 7606109700322, 8004917952738],
        11: [],
      },
      "philips-respironics": {
        "00": [8304015999202],
        "01": [],
        10: [8304015999202],
        11: [],
      },
      "fisher-paykel": {
        "00": [8239627239650],
        "01": [],
        10: [8239627239650],
        11: [],
      },
    },
  },
};

var selectedReferences = {
  machine: "", // air-mini, others
  mask: "", // nasal-mask, full-face-mask, nasal-pillow-mask
  brand: "", // resmed, philips-respironics, fisher-paykel
  specialRequirement: {
    pacemaker: null, // 1, 0
    allergies: null, // 1, 0
  },
};

let maskVariantAndProductsObject = {};
let maskVariantAndProductList = [];

window.onunload = function () {
  document
    .querySelectorAll(".form-check-input.radiobox_item")
    .forEach((item) => {
      item.checked = false;
    });
  return;
};

if (!customElements.get("mask-finder")) {
  customElements.define(
    "mask-finder",
    class MaskFinder extends HTMLElement {
      constructor() {
        super();

        this.innerValue = "";

        this.startQuizBtn = document.getElementById("start-quiz-button");
        this.stepsBtn = document.querySelectorAll(".step__button");
        this.backsBtn = document.querySelectorAll(".back__btn");
        this.machines = document.querySelectorAll(".machine__item");
        this.masks = document.querySelectorAll(".mask__item");
        this.brands = document.querySelectorAll(".brand__item");
        this.specialRequirementTable = document.getElementById(
          "special-requirement-table"
        );
        this.variants = document.querySelectorAll('[id^="variant-"]');
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.startQuizAgainBtn = document.getElementById(
          "start-quiz-again-btn"
        );
      }

      connectedCallback() {
        this.getListProduct();

        this.startQuizBtn.addEventListener("click", () => {
          window.Shopify?.analytics?.publish('custom_mask_finder_start');
          this.switchSlider(2);
        });

        this.startQuizAgainBtn.addEventListener("click", () => {
          this.startQuizAgain();
        });

        this.stepsBtn.forEach((item) => {
          item.addEventListener("click", () => {
            const step = +item.getAttribute("data-action").split("-")[1];
            this.switchSlider(step + 1);
          });
        });

        this.backsBtn.forEach((item) => {
          item.addEventListener("click", () => {
            const step = +item.getAttribute("current-step");
            this.switchSlider(step - 1);
          });
        });

        this.machines.forEach((item) => {
          item.addEventListener("click", () => {
            const id = item.getAttribute("for");
            this.selectItem("machine", id, 2);
          });
        });

        this.masks.forEach((item) => {
          item.addEventListener("click", () => {
            const id = item.getAttribute("for");
            this.selectItem("mask", id, 3);
          });
        });

        this.brands.forEach((item) => {
          item.addEventListener("click", () => {
            const id = item.getAttribute("for");
            this.selectItem("brand", id, 4);
          });
        });

        this.specialRequirementTable.addEventListener(
          "change",
          function (event) {
            if (event.target.type === "radio") {
              const name = event.target.name;
              const value = event.target.value;

              switch (name) {
                case "pacemaker_rb":
                  selectedReferences.specialRequirement.pacemaker = value;
                  break;
                case "silicon_rb":
                  selectedReferences.specialRequirement.allergies = value;
                  break;
              }

              const questionnaireRadioBoxes = document.querySelectorAll(
                ".form-check-input.radiobox_item"
              );

              if (
                (questionnaireRadioBoxes[0].checked ||
                  questionnaireRadioBoxes[1].checked) &&
                (questionnaireRadioBoxes[2].checked ||
                  questionnaireRadioBoxes[3].checked)
              ) {
                var stepButton = document.querySelector(
                  `[data-action="step-5"]`
                );
                stepButton.classList.remove("disabled");
                stepButton.removeAttribute("disabled");
              }
            }
          }
        );
      }

      disconnectedCallback() {
        this.startQuizBtn.removeEventListener("click", () => {});

        this.startQuizAgainBtn.removeEventListener("click", () => {});

        this.machines.forEach((item) => {
          item.removeEventListener("click", () => {});
        });
        this.masks.forEach((item) => {
          item.removeEventListener("click", () => {});
        });
        this.brands.forEach((item) => {
          item.removeEventListener("click", () => {});
        });
        this.specialRequirementTable.removeEventListener("change", (event) => {
          document
            .querySelectorAll(".form-check-input.radiobox_item")
            .forEach((item) => {
              item.checked = false;
            });
        });
        document.querySelectorAll('[id^="variant-"]').forEach((item) => {
          item.removeEventListener("click", () => {});
        });
        document
          .querySelectorAll('[id^="add-to-cart-button-"]')
          .forEach((item) => {
            item.removeEventListener("click", () => {});
          });
      }

      selectItem(type, id, step) {
        selectedReferences[type] = id;
        window.Shopify?.analytics?.publish('custom_mask_finder_step', {
          step: step,
          selection_type: type,
          selection_value: id,
        });

        this[`${type}s`].forEach((item) => {
          const isChecked = item.control.checked;
          if (isChecked) {
            item.classList.add("selected-product");
          } else {
            item.classList.remove("selected-product");
          }
        });

        // step 5 validate at line 316
        const stepButton = document.querySelector(
          `[data-action="step-${step}"]`
        );
        stepButton.classList.remove("disabled");
        stepButton.removeAttribute("disabled");
      }

      startQuizAgain() {
        const listProgress = document.querySelectorAll(`[id*="progress-step"]`);

        const [first, ...others] = listProgress;

        others.forEach((el) => {
          if (el.classList.contains("active")) {
            el.classList.remove("active");
          }
          if (el.classList.contains("done")) {
            el.classList.remove("done");
          }
        });

        document.querySelectorAll(".selected-product").forEach((el) => {
          el.classList.remove("selected-product");
        });

        this.stepsBtn.forEach((item) => {
          item.classList.add("disabled");
          item.setAttribute("disabled", true);
        });

        document
          .querySelectorAll(".form-check-input.radiobox_item")
          .forEach((item) => {
            item.checked = false;
          });

        const recommends = document.getElementById("result");
        this.removeAllChildNodes(recommends);
        const otherRecommends = document.getElementById(
          "other-recommendations"
        );
        this.removeAllChildNodes(otherRecommends);

        this.switchSlider(2);
      }

      removeAllChildNodes(parent) {
        while (parent.firstChild) {
          parent.removeChild(parent.firstChild);
        }
      }

      switchSlider(step) {
        let target = document.getElementById("quiz-form");
        window.scrollTo({ top: target.offsetTop - 50, behavior: "smooth" });

        let progress = document.getElementById("progress");

        const listProgress = document.querySelectorAll(`[id*="progress-step"]`);

        const progressStep2 = listProgress[0];
        const progressStep3 = listProgress[1];
        const progressStep4 = listProgress[2];
        const progressStep5 = listProgress[3];

        if (step == 1) {
          // step 1 is default
          progress.classList.add("hidden");
          document
            .querySelectorAll(".quiz-form__step")
            .forEach(function (item) {
              if (item.id.includes("step-1")) item.classList.remove("hidden");
              else item.classList.add("hidden");
            });
        }
        if (step == 2) {
          progress.classList.remove("hidden");
          document
            .querySelectorAll(".quiz-form__step")
            .forEach(function (item) {
              if (item.id.includes("step-2")) item.classList.remove("hidden");
              else item.classList.add("hidden");
            });
          progressStep2.classList.add("active");
          if (progressStep2.classList.contains("done")) {
            progressStep2.classList.remove("done");
          }
          if (progressStep3.classList.contains("active")) {
            progressStep3.classList.remove("active");
          }
        }
        if (step == 3) {
          document
            .querySelectorAll(".quiz-form__step")
            .forEach(function (item) {
              if (item.id.includes("step-3")) item.classList.remove("hidden");
              else item.classList.add("hidden");
            });
          progressStep2.classList.add("done");
          progressStep3.classList.add("active");
          if (progressStep3.classList.contains("done")) {
            progressStep3.classList.remove("done");
          }
          if (progressStep4.classList.contains("active")) {
            progressStep4.classList.remove("active");
          }
        }
        if (step == 4) {
          document
            .querySelectorAll(".quiz-form__step")
            .forEach(function (item) {
              if (item.id.includes("step-4")) item.classList.remove("hidden");
              else item.classList.add("hidden");
            });
          progressStep3.classList.add("done");
          progressStep4.classList.add("active");
          if (progressStep4.classList.contains("done")) {
            progressStep4.classList.remove("done");
          }
          if (progressStep5.classList.contains("active")) {
            progressStep5.classList.remove("active");
          }
        }
        if (step == 5) {
          document
            .querySelectorAll(".quiz-form__step")
            .forEach(function (item) {
              if (item.id.includes("step-5")) item.classList.remove("hidden");
              else item.classList.add("hidden");
            });

          progressStep4.classList.add("done");
          progressStep5.classList.add("active");
          if (progressStep5.classList.contains("done")) {
            progressStep5.classList.remove("done");
          }
        }

        if (step == 6) {
          document
            .querySelectorAll(".quiz-form__step")
            .forEach(function (item) {
              if (item.id.includes("step-6")) item.classList.remove("hidden");
              else item.classList.add("hidden");
            });
          progress.classList.add("hidden");
          this.getRecommendation();
        }
      }

      async getListProduct() {
        const response = await fetch(`/collections/cpap-masks/products.json`);

        const { products } = await response.json();

        maskVariantAndProductList = products;

        maskVariantAndProductsObject = products.reduce((acc, cur) => {
          return {
            ...acc,
            [cur.id]: cur,
          };
        }, {});
      }

      async getRecommendation() {
        const recommendation = { ...selectedReferences };

        let recommends = [];

        const questionValue =
          recommendation.specialRequirement.pacemaker +
          recommendation.specialRequirement.allergies;

        if (recommendation.machine === "air-mini") {
          recommends =
            maskFinderResult["air-mini"]?.[recommendation.mask]?.[
              recommendation.brand
            ]?.[questionValue] || [];
        } else {
          recommends =
            maskFinderResult["others"]?.[recommendation.mask]?.[
              recommendation.brand
            ]?.[questionValue] || [];
        }

        const { recommendsData, otherRecommendsData } =
          maskVariantAndProductList.reduce(
            (acc, cur) => {
              if (recommends.includes(cur.id)) {
                return {
                  ...acc,
                  recommendsData: acc.recommendsData.concat(cur),
                };
              }
              return {
                ...acc,
                otherRecommendsData: acc.otherRecommendsData.concat(cur),
              };
            },
            {
              recommendsData: [],
              otherRecommendsData: [],
            }
          );

        window.Shopify?.analytics?.publish('custom_mask_finder_result', {
          recommended_count: recommendsData.length,
          recommended_products: recommendsData.map(p => ({ id: p.id, title: p.title })),
          machine: recommendation.machine,
          mask: recommendation.mask,
          brand: recommendation.brand,
        });

        this.renderResult(recommendsData);
        this.renderOtherRecommendations(otherRecommendsData);
      }

      manageInnerValue(newValue, productId) {
        if (typeof newValue !== "undefined") {
          this.changeButtonValue(newValue);
          this.innerValue = newValue;
        }

        if (typeof productId !== "undefined") {
          let errorDiv = document.getElementById(`error-${productId}`);
          errorDiv?.classList.add("tw-hidden");
        }
        return this.innerValue;
      }

      changeButtonValue(buttonId) {
        document.querySelectorAll('[id^="variant-"]').forEach((variant) => {
          variant.classList.remove("selected-variant");
        });

        const selectedButton = document.querySelector(`#variant-${buttonId}`);

        if (selectedButton) {
          selectedButton.classList.add("selected-variant");
        }
      }

      renderResult(result) {
        // render image and product title
        let heading = document.getElementById("result-heading");

        if (result.length === 0) {
          heading.innerHTML = `Sorry, we don't have any product that matches your requirements`;
          return;
        } else if (result.length === 1) {
          heading.innerHTML = `Your top 1 CPAP mask recommendation`;
        } else {
          heading.innerHTML = `Your top ${result.length} CPAP mask recommendations`;
        }

        result.map((item) => {
          let product = document.createElement("div");
          const src = item?.media?.[0].src || item?.images?.[0].src;
          product.classList.add("product");
          product.innerHTML = `
                <div class=" tw-flex tw-w-full tw-flex-col lg:tw-flex-row tw-justify-start tw-items-center tw-p-6 tw-border lg:tw-space-x-6 tw-border-gray-300 tw-rounded-2xl tw-bg-white">
                  <img class="responsive-image"  src="${src}"
                     alt="${item.title}" width="200" height="200">
                  <div class="tw-flex tw-flex-col tw-gap-y-2 tw-text-start tw-items-start">
                    <div class="tw-uppercase tw-text-gray-light-1">${
                      item.vendor
                    }</div>
                    <div class="tw-font-semibold tw-text-2xl">${
                      item.title
                    }</div>


                    <div class="tw-flex tw-flex-wrap tw-gap-4 tw-pt-4">
                    ${item.variants
                      .map((variant) => {
                        return `
                          <button
                            class="tw-px-4 tw-py-2 tw-border tw-border-gray-300 tw-rounded-md hover:tw-scale-105 tw-transition-transform tw-duration-200"
                            id="variant-${variant.id}"
                          >
                            ${variant.title}
                          </button>
                        `;
                      })
                      .join(" ")}
                    </div>

                    <div class="tw-space-x-6 tw-pt-4 tw-text-red-500 tw-hidden" id="error-${
                      item.id
                    }">Please select a size</div>
                    <div class="tw-flex tw-gap-4 tw-pt-4">
                      <a href="${item.url}">
                        <button class="tw-px-4 lg:tw-px-8 tw-py-4 tw-border tw-border-gray-300 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-duration-200">
                          Explore more
                        </button>
                      </a>
                      <button
                      class="tw-flex tw-items-center tw-justify-center tw-px-4 lg:tw-px-8 tw-py-4 tw-border tw-rounded-full tw-bg-primary hover:tw-scale-105 tw-transition-transform tw-duration-200"
                      id="add-to-cart-button-${item.id}"
                      product-id="${item.id}"
                    >
                    <span>
                    Add to cart
                    </span>
                      <div class="loading__spinner hidden">
                          <svg
                            aria-hidden="true"
                            focusable="false"
                            class="spinner"
                            viewBox="0 0 66 66"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                      </div>
                    </button>
                    </div>
                  </div>
                </div>
              `;
          document.getElementById("result").appendChild(product);
        });

        document.querySelectorAll('[id^="variant-"]').forEach((item) => {
          item.addEventListener("click", () => {
            const variantId = item.id.split("-")[1];
            const productId = item.getAttribute("product-id");
            this.manageInnerValue(variantId, productId);
          });
        });

        document
          .querySelectorAll('[id^="add-to-cart-button-"]')
          .forEach((item) => {
            item.addEventListener("click", () => {
              const variantId = item.getAttribute("variant-id");
              const productId = item.getAttribute("product-id");
              this.addToCart(productId, variantId);
            });
          });
      }

      renderOtherRecommendations(products) {
        let otherRecommendations = document.getElementById(
          "other-recommendations"
        );

        products.map((item) => {
          const src = item?.media?.[0].src || item?.images?.[0].src;
          let product = document.createElement("div");
          product.classList.add("product");
          product.innerHTML = `
              <div class=" tw-flex tw-w-full tw-flex-col lg:tw-flex-row tw-justify-start tw-items-center tw-p-6 tw-border lg:tw-space-x-6 tw-border-gray-300 tw-rounded-2xl tw-bg-white">
                <img class="responsive-image" src="${src}" alt="${
            item.title
          }" width="200" height="200">
                  <div class="tw-flex tw-flex-col tw-gap-y-2 tw-text-start tw-items-start">
                    <div class="tw-uppercase tw-text-gray-light-1">${
                      item.vendor
                    }</div>
                    <div class="tw-font-semibold tw-text-2xl">${
                      item.title
                    }</div>

                    <div class="tw-flex tw-flex-wrap tw-gap-4 tw-pt-4">
                    ${
                      item.variants.length > 1
                        ? item.variants
                            .map((variant) => {
                              return `
                          <button
                          class="tw-px-4 tw-py-2 tw-border tw-border-gray-300 tw-rounded-md hover:tw-scale-105 tw-transition-transform tw-duration-200 ${
                            variant.available
                              ? ""
                              : "tw-opacity-50 tw-cursor-not-allowed hover:tw-scale-100"
                          }"
                            ${variant.available ? "" : "disabled"}
                            product-id="${item.id}"
                            id="variant-${variant.id}"
                          >
                            ${variant.title}
                          </button>
                        `;
                            })
                            .join(" ")
                        : ""
                    }
                    </div>
                    ${
                      item.variants.length > 1
                        ? `<div class="tw-space-x-6 tw-pt-4 tw-text-red-500 tw-hidden" id="error-${item.id}">Please select a size</div>
                            <div class="tw-flex tw-gap-4 tw-pt-4">
                              <a href="${item.url}">
                                <button class="tw-px-4 lg:tw-px-8 tw-py-4 tw-border tw-border-gray-300 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-duration-200">
                                  Explore more
                                </button>
                              </a>
                              <button
                                class="tw-flex tw-items-center tw-justify-center tw-px-4 lg:tw-px-8 tw-py-4 tw-border tw-rounded-full tw-bg-primary hover:tw-scale-105 tw-transition-transform tw-duration-200"
                                id="add-to-cart-button-${item.id}"
                                product-id="${item.id}"
                              >
                              <span>
                                Add to cart
                              </span>
                                <div class="loading__spinner hidden">
      <svg
        aria-hidden="true"
        focusable="false"
        class="spinner"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
    </div>
                              </button>
                            </div>`
                        : ` <div class="tw-space-x-6 tw-pt-4 tw-text-red-500 tw-hidden" id="error-${item.id}">Please select a size</div>
                          <div class="tw-flex tw-gap-4 tw-pt-4">
                            <a href="${item.url}">
                              <button class="tw-px-4 lg:tw-px-8 tw-py-4 tw-border tw-border-gray-300 tw-rounded-full hover:tw-scale-105 tw-transition-transform tw-duration-200">
                                Explore more
                              </button>
                            </a>
                            <button
                              class="tw-flex tw-items-center tw-justify-center tw-px-4 lg:tw-px-8 tw-py-4 tw-border tw-rounded-full tw-bg-primary hover:tw-scale-105 tw-transition-transform tw-duration-200"
                              id="add-to-cart-button-${item.id}"
                              product-id="${item.id}"
                              variant-id="${item.variants[0].id}"
                            >
                            <span>
                            Add to cart
                          </span>
                              <div class="loading__spinner hidden">
                                <svg
                                  aria-hidden="true"
                                  focusable="false"
                                  class="spinner"
                                  viewBox="0 0 66 66"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                </svg>
                              </div>
                            </button>
                          </div>`
                    }
                  </div>
                </div>
              `;
          /* Seperate the items as above as we need to add product with 1 variant directly */

          otherRecommendations.appendChild(product);
        });

        document.querySelectorAll('[id^="variant-"]').forEach((item) => {
          item.addEventListener("click", () => {
            const variantId = item.id.split("-")[1];
            const productId = item.getAttribute("product-id");
            this.manageInnerValue(variantId, productId);
          });
        });

        document
          .querySelectorAll('[id^="add-to-cart-button-"]')
          .forEach((item) => {
            item.addEventListener("click", () => {
              const variantId = item.getAttribute("variant-id");
              const productId = item.getAttribute("product-id");
              this.addToCart(+productId, variantId ? +variantId : null);
            });
          });
      }

      addToCart(productId, variantId) {
        let variantProductId = variantId || this.manageInnerValue();
        let errorDiv = document.getElementById(`error-${productId}`);

        if (variantProductId === undefined) {
          errorDiv.innerHTML = "Please select a size";
          errorDiv.classList.remove("tw-hidden");
          return;
        }

        // check if variantProductId is belong to the same product in maskVariantAndProductsObject
        let product = maskVariantAndProductsObject[productId];

        let isSelectedVariantInProduct = product.variants.find((variant) => {
          return variant.id === +variantProductId;
        });

        if (!isSelectedVariantInProduct) {
          errorDiv.innerHTML = "Please select a size";
          errorDiv.classList.remove("tw-hidden");
          return;
        }

        const formData = new FormData();

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender
              ? this.cart.getSectionsToRender().map((section) => section.id)
              : []
          );
          formData.append("sections_url", window.location.pathname);
          formData.append("id", variantProductId);
          formData.append("quantity", "1");
        } else {
          formData.append("id", variantProductId);
          formData.append("quantity", "1");
        }

        const config = typeof fetchConfig === 'function' ? fetchConfig("javascript") : {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
        };
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        config.body = formData;

        const button = document.getElementById(
          `add-to-cart-button-${productId}`
        );
        button.classList.add("loading");
        button.classList.add("tw-opacity-50");
        button.childNodes[1].classList.add("invisible");
        button.childNodes[3].classList.remove("hidden");
        button.setAttribute("aria-disabled", true);

        fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', config)
          .then((response) => response.json())
          .then((data) => {
            if (data.status === 422) {
              errorDiv.innerHTML = data.description;
              errorDiv.classList.remove("tw-hidden");
              return;
            }

            window.Shopify?.analytics?.publish('custom_mask_finder_add_to_cart', {
              product_id: productId,
              variant_id: variantProductId,
              product_title: maskVariantAndProductsObject[productId]?.title,
            });

            if (!this.cart) {
              window.location = window.routes?.cart_url || '/cart';
              return;
            }

            this.cart.setActiveElement && this.cart.setActiveElement(document.activeElement);

            // Dispatch cart update event for Horizon theme
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                detail: {
                  productVariantId: variantProductId,
                  cartData: data,
                },
              })
            );

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents && this.cart.renderContents(data);
                  });
                },
                { once: true }
              );
              quickAddModal.hide && quickAddModal.hide(true);
            } else {
              this.cart.renderContents && this.cart.renderContents(data);
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            button.removeAttribute("aria-disabled");
            button.classList.remove("loading");
            button.classList.remove("tw-opacity-50");
            button.childNodes[1].classList.remove("invisible");
            button.childNodes[3].classList.add("hidden");
            button.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
          });
      }
    }
  );
}
